// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-qv24","icon":"styles_icon__1KNaI"};